export const TRANSLATE_SEPERATE = `\n----------------\n`
